module.exports = __webpack_public_path__ + "img/fornitori-white.6b6718a5.svg";